// Centralized content used across pages

export const CONTACT = {
  schoolName: "Aachary Dev Development Holistic School",
  shortName: "ADHD School",
  physioName: "Bhadrak Physiotherapy & Rehab Centre",
  phone: "+91 94372 98628",
  phoneTel: "+919437298628",
  whatsappNumber: "919437298628",
  address:
    "Bonth Chhak, Netaji Nagar Road, Near LIC Office, Bagurai, Bhadrak, Odisha – 756100",
  mapShareUrl: "https://share.google/wEtZjXF8zE2akcrFT",
  mapEmbedSrc:
    "https://www.google.com/maps?q=Bonth+Chhak+Netaji+Nagar+Road+LIC+Office+Bagurai+Bhadrak+Odisha+756100&output=embed",
  rating: 4.9,
  reviewCount: 150,
};

// Image set (placeholders supplied by design agent)
export const IMAGES = {
  heroSchool:
    "/home-hero.jpeg",
  therapy1:
    "https://images.unsplash.com/photo-1552873816-636e43209957?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  therapy2:
    "https://images.unsplash.com/photo-1624272949900-9ae4c56397e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  physioHero:
    "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  doctor:
    "https://images.unsplash.com/photo-1581056771107-24ca5f033842?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  principal:
    "/principal.jpeg",
  gallery1:
    "https://images.unsplash.com/photo-1594608661623-aa0bd3a69d98?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gallery2:
    "https://images.unsplash.com/photo-1588075592446-265fd1e6e76f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gallery3:
    "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gallery4:
    "https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gallery5:
    "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gallery6:
    "https://images.unsplash.com/photo-1607582544388-fe17a55e54bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// School pillars
export const PILLARS = [
  { key: "academic", icon: "BookOpen", label: "Academic excellence" },
  { key: "personality", icon: "Sparkles", label: "Personality development" },
  { key: "comm", icon: "MessageCircle", label: "Communication skills" },
  { key: "social", icon: "Users", label: "Social & emotional growth" },
  { key: "discipline", icon: "ShieldCheck", label: "Discipline & values" },
  { key: "inclusive", icon: "HandHeart", label: "Inclusive learning" },
  { key: "individual", icon: "User", label: "Individual attention" },
  { key: "confidence", icon: "Star", label: "Confidence building" },
];

// School services (primary)
export const SCHOOL_SERVICES = [
  {
    id: "ot",
    icon: "HandHeart",
    title: "Occupational Therapy (OT)",
    desc: "Helping children improve motor skills and daily activities — from holding a pencil to dressing independently.",
  },
  {
    id: "pt",
    icon: "Activity",
    title: "Physiotherapy (PT)",
    desc: "Enhancing movement, balance and physical strength through age-appropriate guided exercises.",
  },
  {
    id: "speech",
    icon: "MessageCircle",
    title: "Speech Therapy",
    desc: "Improving communication, language and articulation so every child finds their voice.",
  },
  {
    id: "si",
    icon: "Waves",
    title: "Sensory Integration (SI)",
    desc: "Supporting children with sensory processing challenges in a safe, structured environment.",
  },
  {
    id: "spec",
    icon: "GraduationCap",
    title: "Special Education",
    desc: "Customised teaching methods built around each child's pace, strengths and learning style.",
  },
];

// FAQ — high priority section
export const FAQS = [
  {
    q: "Why should I choose ADHD School for my child?",
    a: "We focus on academics, communication skills, personality development and emotional growth — together, not in isolation.",
  },
  {
    q: "Will my child receive individual attention?",
    a: "Yes. Every child receives personalised care and guidance according to their needs, abilities and pace.",
  },
  {
    q: "Do you provide therapy services?",
    a: "Yes. We offer Occupational Therapy, Physiotherapy, Speech Therapy, Sensory Integration Therapy and Special Education.",
  },
  {
    q: "Is the environment child-friendly?",
    a: "Yes. Our teachers create a safe, caring and positive environment so every child feels secure and seen.",
  },
  {
    q: "Do you help children with communication and confidence?",
    a: "Yes. We encourage communication, creativity, confidence and social interaction through structured daily activities.",
  },
  {
    q: "Are extracurricular activities included?",
    a: "Yes. We maintain a balance between studies and activities — art, movement, music and outdoor play — for holistic development.",
  },
  {
    q: "Are teachers supportive?",
    a: "Yes. Our teachers are highly caring, experienced and dedicated to each child's progress.",
  },
  {
    q: "Is the school suitable for children with special needs?",
    a: "Yes. We provide holistic support and individualised learning approaches for neurodivergent and special-needs children.",
  },
];

// Parent reviews
export const SCHOOL_REVIEWS = [
  {
    name: "Sangeeta Mishra",
    role: "Parent",
    text: "This school is one of the best in Bhadrak. The teachers focus not only on studies but also on overall personality development.",
  },
  {
    name: "Prakash Behera",
    role: "Parent",
    text: "Excellent environment for children. My son has improved a lot in communication and confidence.",
  },
  {
    name: "Lipsa Mohanty",
    role: "Parent",
    text: "Highly recommended school in Bhadrak. Teachers are very caring and supportive.",
  },
  {
    name: "Rakesh Sahoo",
    role: "Parent",
    text: "Perfect balance of studies and extracurricular activities.",
  },
  {
    name: "Anjali Das",
    role: "Parent",
    text: "I am happy with the progress of my child. The school gives individual attention.",
  },
];

// Physio services (secondary)
export const PHYSIO_SERVICES = [
  { icon: "Dumbbell", title: "Therapeutic Exercise" },
  { icon: "Spline", title: "Back Pain Treatment" },
  { icon: "Footprints", title: "Knee Pain Treatment" },
  { icon: "PersonStanding", title: "Hip Pain Treatment" },
  { icon: "Footprints", title: "Foot & Ankle Pain" },
  { icon: "Bone", title: "Arthritis Treatment" },
  { icon: "Flame", title: "Heat Therapy" },
  { icon: "Brain", title: "Neurological Physiotherapy" },
  { icon: "Spline", title: "Spinal Injury Rehabilitation" },
  { icon: "Baby", title: "Pediatric Physiotherapy" },
  { icon: "Accessibility", title: "Geriatric Physiotherapy" },
  { icon: "HandHeart", title: "Occupational Therapy" },
  { icon: "Activity", title: "Physical Therapy" },
  { icon: "Stethoscope", title: "Post-Surgery Rehabilitation" },
];

// Specialized treatments & rehabilitation programs (title + description)
export const PHYSIO_SPECIALIZED = [
  {
    icon: "Bone",
    title: "THR / TKR (Total Hip / Total Knee Replacement)",
    desc: "Specialized physiotherapy and rehabilitation programs for patients undergoing Total Hip Replacement (THR) and Total Knee Replacement (TKR), focusing on pain management, mobility restoration, strength improvement, and recovery to daily activities.",
  },
  {
    icon: "Footprints",
    title: "Flat Foot / Knock Knee / Club Foot Correction",
    desc: "Assessment and physiotherapy management for congenital foot and lower limb deformities, including flat foot, knock knee, and club foot, with customized exercises and corrective rehabilitation programs to improve posture, gait, and functional movement.",
  },
  {
    icon: "Brain",
    title: "Stroke Rehabilitation (Paralysis)",
    desc: "Comprehensive rehabilitation for stroke and paralysis patients, aimed at improving muscle strength, balance, coordination, mobility, and independence through individualized therapy programs.",
  },
];

export const PATIENT_REVIEWS = [
  {
    name: "Bibhuti Bhusan",
    role: "Patient",
    text: "Very good location area, doctor and all staff are dedicated to the patient first.",
  },
  {
    name: "Saraswati Rout",
    role: "Patient",
    text: "Excellent experience. Supportive staff and quality treatment.",
  },
  {
    name: "Manoj Pradhan",
    role: "Patient",
    text: "Very good service and quality care.",
  },
];

// Footer quick links (route paths)
export const QUICK_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Principal", path: "/principal" },
  { label: "Doctor", path: "/doctor" },
  { label: "Reviews", path: "/#reviews" },
  { label: "Gallery", path: "/gallery" },
  { label: "Contact", path: "/contact" },
];
